import { Component, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { QuickLinkResult } from '../models/search.model';
import { SelectItem } from 'primeng/api';
import { SearchService } from '../services/search.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrls: ['./quick-links.component.css']
})
export class QuickLinksComponent implements OnInit {
  filelocationapi: string =environment.apiEndpoint+"/Report/DownloadReportByFileName?fileName=";
  first:number =0;
  dayCnt:number;
  title:string;
  //reportNames: SelectItem[];
  //countries: SelectItem[];
  //fasPosts: SelectItem[];
  //distributionTypes: SelectItem[];
  titleNames:SelectItem[];
  
  results: QuickLinkResult[];
  constructor(private route:ActivatedRoute,
             private searchService: SearchService) {
    this.titleNames = [
      { label: "Today's Reports", value: 1 },
      { label: "Past 3 Days Reports", value:3  },
      { label: "Past 5 Days Reports", value: 5 },
      { label: "Past 7 Days Reports", value: 7 },
      { label: "Past Month's Reports", value: 30 }
    ];

   }

  ngOnInit() {

    this.route.paramMap.subscribe(params => {
      this.dayCnt = +params.get('dayCnt');
      this.title =this.titleNames.filter(x=>x.value == this.dayCnt)[0].label;
      this.LoadData(this.dayCnt);
      this.first =0;
    });
  }
  paginate(event) {
    this.first = event.first;
}

   private LoadData(dayCnt:number)
   { 
    
    var currentDate = new Date();
    currentDate.setHours(23,59,59,999);
    var fromDate = new Date().setDate(currentDate.getDate() - dayCnt);
    this.searchService.getQuickLinkResults$(new Date(fromDate).toDateString(),currentDate.toLocaleString()).subscribe(resp => {
      // console.log(resp);
       if (resp.ok) {
         this.results = resp.body;
         this.results.sort((a, b) => {
           if (a.publishedOn > b.publishedOn) return -1;
           if (a.publishedOn < b.publishedOn) return 1;
           return 0;
         });
      
        // console.log(this.searchResults);
       }
     });

      

   }
  
}



// WEBPACK FOOTER //
// ./src/app/quick-links/quick-links.component.ts